import Routes from "security-app/routing/Routes";
export const PAGE_NAV_TITLE = "Investigations";
const investigationsPageNavigation = {
  description: PAGE_NAV_TITLE,
  children: [
    { description: "Open", path: Routes.INVESTIGATIONS.LIST, exactPathMatch: true },
    { description: "Archived", path: Routes.INVESTIGATIONS.ARCHIVED },
    { description: "Config", path: Routes.INVESTIGATIONS.CONFIGURATION, permissions: "investigations:edit" }
  ]
};
export default investigationsPageNavigation;
